var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-card",
        { staticClass: "pa-4" },
        [
          _c("v-card-title", [_vm._v("Калькулятор")]),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("v-text-field", {
                attrs: { label: "Площадь (м²)", type: "number", min: "0" },
                model: {
                  value: _vm.area,
                  callback: function ($$v) {
                    _vm.area = _vm._n($$v)
                  },
                  expression: "area",
                },
              }),
              _vm._v(" "),
              _c("v-select", {
                attrs: { items: _vm.layerOptions, label: "Количество слоев" },
                model: {
                  value: _vm.layers,
                  callback: function ($$v) {
                    _vm.layers = $$v
                  },
                  expression: "layers",
                },
              }),
              _vm._v(" "),
              _c("v-select", {
                attrs: { items: _vm.surfaceOptions, label: "Тип поверхности" },
                model: {
                  value: _vm.surfaceType,
                  callback: function ($$v) {
                    _vm.surfaceType = $$v
                  },
                  expression: "surfaceType",
                },
              }),
              _vm._v(" "),
              _vm.calculatedAmount !== null
                ? _c("v-alert", { attrs: { type: "info" } }, [
                    _vm._v(
                      "\n        Расход материала: " +
                        _vm._s(_vm.calculatedAmount.toFixed(2)) +
                        " кг\n      "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }